<ngx-heka-heka-navigation-container
  [appTitle]="'APPS.CUSTOMER_PORTAL.TITLE' | translate"
  appImageLink="assets/images/heka-logo-symbols/hplus.svg"
  [collapseText]="'MENU.COLLAPSE' | translate"
  [accountMenu]="accountMenu()"
  [appMenuItems]="appMenuItems()"
  [appImageClickHandler]="openHcp"
  [helpLink]="helpLink"
  [loading]="(loadingService.getLoading().asObservable() | async) || false"
  (onDomainChange)="domainHandlerService.switchDomainAndReload($event.domainId)"
  startPage="/multi-domain-mgmt">
  <ng-content/>
</ngx-heka-heka-navigation-container>